module.exports = __webpack_public_path__ + "img/title.884defe9.png";